import * as React from 'react';

import { createReactRenderer } from 'helpers/react-renderer';

import DiscountRuleDropdown from '../DiscountRuleDropdown';

interface Props {
  className?: string;
  initialValue?: string | number;
  isDirtyOnChange?: boolean;
  isDisabled?: boolean;
  name: string;
}

enum DISCOUNT_CALC_TYPE {
  PERCENTAGE = 'percentage',
  FIXED = 'fixed',
}

const DiscountRuleDiscountType: React.FC<Props> = ({
  className = '',
  initialValue,
  isDirtyOnChange,
  isDisabled,
  name,
}) => {
  const options = [
    {
      value: DISCOUNT_CALC_TYPE.PERCENTAGE,
      label: (
        <span>
          Percentage <span className="notranslate">(%)</span>
        </span>
      ),
    },
    {
      value: DISCOUNT_CALC_TYPE.FIXED,
      label: (
        <span>
          Fixed amount off (<var>{window.merchantos.locale.currency_symbol}</var>)
        </span>
      ),
    },
  ];

  const initialOption =
    (initialValue && options.find((option) => option.value === initialValue)) || options[0];

  return (
    <DiscountRuleDropdown
      className={className}
      initialOptions={[initialOption]}
      isDirtyOnChange={isDirtyOnChange}
      isDisabled={isDisabled}
      isSearchable={false}
      name={name}
      options={options}
      placeholder="Select the discount type"
    />
  );
};

const RenderedComponent = createReactRenderer({
  component: DiscountRuleDiscountType,
  selector: '[data-react-root="DiscountRuleDiscountType"]',
});

window.history.onChangeState(
  {
    id: undefined,
    name: 'discount_rule.views.discount_rule',
  },
  () => {
    RenderedComponent.mount();
  },
  () => {
    RenderedComponent.unmount();
  }
);

export default DiscountRuleDiscountType;
